export const BEHAVIOUR_TYPES = {
  QUEUE: 'QUEUE',
  STACK: 'STACK'
};

const getValidBehaviour = (envBehaviour) => {
  const behaviourDefined = Object.values(BEHAVIOUR_TYPES).find((behaviour) => behaviour === envBehaviour);
  return behaviourDefined || BEHAVIOUR_TYPES.STACK;
};

export const BEHAVIOUR = getValidBehaviour(process.env.UNNOTIFICATIONSQUEUE_BEHAVIOUR);
